export default __webpack_public_path__ + "static/media/children.dfb82124.jpg";